export default "__VITE_ASSET__b7ac67ca__"